export default class ArrayTool{
    /**
     * Utility function to groups elements from an array by property name or meeting a certain condition
     * @param {*} array A List of objects or values to evaluate
     * @param {string|function} groupingKey A property name or a function that receives a single parameter. If function, it will be called once for every element in the array, and should return a value that will be used to group the elements.
     * @returns An object whose property names match the values returned by the evalFunction, and whose values are list of items with shared property or met condition from the evalFunction.
     * 
     * @example
     * let myList = [1,2,3,11,12,31,41,42,43,44];
        gn.array.groupBy( myList , (item)=>{
            return item < 10
        } );
        // Returns lists of elements: {true:[...], false:[...]}

        let myList = [1,2,3,11,12,31,41,42,43,44];
        gn.array.groupBy( myList , (item)=>{
            return Math.floor( item/10 )
        } );
        // Returns lists of elements: { 0:[...], 1:[...], 3:[...], 4:[...] }
     */
    static groupBy( array, groupingKey ) {
        let result = {
        }
        array.forEach(element => {
            let groupName;
            if( groupingKey instanceof Function ){
                groupName = groupingKey(element);
            }else{
                groupName = element[groupingKey];
            }
            if( result[groupName] == undefined ) {
                result[groupName] = [];
            }
            result[groupName].push(element);
        });
        return result;
    }


    /**
     * Utility function to count the number of times each element in an array meets certain condition
     * Can be used to group-count
     * @param {*} array A List of objects or values to evaluate
     * @param {string|function} groupingKey A property name or a function that receives a single parameter. If function, it will be called once for every element in the array, and should return a value that will be used to group the elements.
     * @returns An object whose property names match the values returned by the evalFunction, and whose values are the number of times that value was returned by the evalFunction.
     * 
     * @example
     * let myList = [1,2,3,11,12,31,41,42,43,44];
        gn.array.countBy( myList , (item)=>{
            return item < 10
        } );
        // Returns: { true:19, false:3 }

        let myList = [1,2,3,11,12,31,41,42,43,44];
        gn.array.countBy( myList , (item)=>{
            return Math.floor( item/10 )
        } );
        // Returns: { 0:3, 1:2, 3:1, 4:4 }
     */
    static countBy( array, groupingKey ) {
        let result = {
        }
        array.forEach(element => {
            let groupName;
            if( groupingKey instanceof Function ){
                groupName = groupingKey(element);
            }else{
                groupName = element[groupingKey];
            }
            if( result[groupName] == undefined ) {
                result[groupName] = 0;
            }
            result[groupName]++;
        });
        return result;
    }
}